let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("daCl8"), load("ly27m"), load("3xec3"), load("i3TSs"), load("4sZyu")]).then(() => parcelRequire('3iK0z'));